import { LotOverview } from './Overview/LotOverview';
import { LotGallery } from './Gallery/LotGallery';
import { LotSpecs } from './Specs/LotSpecs';
import { LotAttachments } from './Attachments/LotAttachments';
import { LotVideos } from './Videos/LotVideos';
import { LotHeader } from './Header/LotHeader';
import { LotContentHeader } from './ContentHeader/LotContentHeader';
import { LotAddedServices } from './AddedServices/LotAddedServices';
import { LotAppointments } from './Appointments/LotAppointments';
import { LotSalesSupport } from './SalesSupport/LotSalesSupport';

const LotComponents = {
  Gallery: LotGallery,
  Overview: LotOverview,
  Specs: LotSpecs,
  Attachments: LotAttachments,
  Videos: LotVideos,
  Header: LotHeader,
  ContentHeader: LotContentHeader,
  AddedServices: LotAddedServices,
  Appointments: LotAppointments,
  SalesSupport: LotSalesSupport,
};

export default LotComponents;
